import { Chip, Slider, Stack, Text } from '@/design';
import type { PointCloudPerformanceSnapshot } from './model';

interface PointCloudDensityControlsProps {
  densityTarget: number;
  performance: PointCloudPerformanceSnapshot;
  onDensityTargetChange(value: number): void;
}

export function PointCloudDensityControls({
  densityTarget,
  performance,
  onDensityTargetChange,
}: PointCloudDensityControlsProps) {
  const densityPercent = Math.round(densityTarget * 100);
  const statusLabel =
    densityTarget >= 0.8 ? 'High density' : densityTarget >= 0.5 ? 'Balanced density' : 'Decimated density';

  return (
    <div role="group" aria-label="Point cloud density controls">
      <Stack direction="column" gap={1}>
        <Text as="label" variant="caption">
          Density target
        </Text>
        <Slider
          min={10}
          max={100}
          step={5}
          value={densityPercent}
          aria-label="Point cloud density target"
          onChange={(next) => onDensityTargetChange(next / 100)}
        />
        <Stack direction="row" align="center" gap={1} style={{ flexWrap: 'wrap' }}>
          <Chip icon="whatshot" label={`${densityPercent}%`} variant="neutral" />
          <Chip icon="tune" label={statusLabel} variant="neutral" />
          <Chip
            icon="speed"
            label={`Budget ${Math.round(performance.pointBudget).toLocaleString()}`}
            variant="neutral"
          />
        </Stack>
      </Stack>
    </div>
  );
}
